export default class Salida {
    constructor(fecha_solicitud = '', observacion = '', agencia_id = null) {
        this.fecha_solicitud = new Date().toISOString().slice(0,10);
        this.observacion = observacion;
        this.agencia_id = agencia_id;
    }
}